module.exports = __webpack_public_path__ + "static/media/CloseSmall.a8daddc6.svg";